import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["row"]

  selectAll(event) {
    this.rowTargets.forEach((row) => {
      row.checked = event.currentTarget.checked
      this.#activeTrSelection(row)
    })
    this.#dispatchSelection()
  }

  check(event) {
    this.#activeTrSelection(event.currentTarget)
    this.#dispatchSelection()
  }

  #dispatchSelection() {
    this.dispatch("row-selection-change", {
      detail: { selectedRows: this.#selectedRows() }
    })
  }

  #selectedRows() {
    return this.rowTargets
      .filter(row => row.checked)
      .map(row => row.id)
  }

  #activeTrSelection(checkboxRow) {
    checkboxRow.closest("tr").dataset.selected = checkboxRow.checked
  }
}
